import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import { RECOMMEND_TAG_COPY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { reDirectPage, setDetailPageUrl } from '../../../../../lib/common';
import './RecommendTagDetailNavbar.scss';

const RecommendTagDetailNavbar = (props) => {
  const { recommendTagId } = props;

  return (
    <FixedBottomNavBar className="recommend-tag-detail-navbar">
      <div className="button-group">
        <Button
          color="primary"
          text="복사하기"
          onClick={() => reDirectPage({ path: setDetailPageUrl(RECOMMEND_TAG_COPY_URL_PATH, recommendTagId) })}
        />
      </div>
    </FixedBottomNavBar>
  );
};

export default RecommendTagDetailNavbar;
